"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[541],{

/***/ 30541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_Loading; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(8529);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/pds-react/src/index.ts + 66 modules
var src = __webpack_require__(61810);
// EXTERNAL MODULE: ../../packages/react-hooks/index.ts + 10 modules
var react_hooks = __webpack_require__(90114);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(36557);
// EXTERNAL MODULE: ./constants/zIndex.ts
var zIndex = __webpack_require__(90122);
;// CONCATENATED MODULE: ./components/User/_components/common/Loading/index.styles.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eicvh0d3"
} : 0)("position:absolute;z-index:", zIndex/* Z_INDEX.loading */.k.loading, ";top:0;left:0;overflow:none;width:100%;height:100%;" + ( true ? "" : 0));
var StackInnerWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "eicvh0d2"
} : 0)( true ? {
  name: "13udsys",
  styles: "height:100%"
} : 0);
var FlexTipWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "eicvh0d1"
} : 0)( true ? {
  name: "19u4ht3",
  styles: "flex:1;margin-bottom:16px"
} : 0);
var StackTipInnerWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "eicvh0d0"
} : 0)("width:auto;padding:16px;border:1px solid ", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.skyblue_200;
}, ";margin-top:40px;background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.skyblue_50;
}, ";border-radius:8px;" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./components/User/_components/common/Loading/index.constants.ts
var tipTexts = [['고객별로 링크를 생성하여 추적하면', '각 고객별로 어떤 고객이 읽었는지 안읽었는지', '심층적으로 분석이 가능해요'], ['원하는 기능 업데이트가 있나요?', '아래 채널톡 버튼을 눌러 남겨보세요'], ['이 잠재고객은 몇 시에 출근할까?', '파일의 열람 시간을 확인해보세요'], ['지난 1주 내 2번 이상 자료를 본 고객이 있다면?', '추가로 설득해 보세요'], ['첨부한 자료를 “열어보고 싶게”', '궁금증 생기는 콜드메일을 써보세요'], ['탐나는 고객이 방금 파일을 열어봤나요?', '2시간 정도 후에 팔로우업을 해보세요!'], ['추적용 링크를 만들어', '홈페이지나 우리회사 SNS 페이지에 걸어보세요'], ['지금 스트레칭 한 번 하세요.', '중요한 고객의 반응이 오면,', '세일즈클루가 이메일로 알려드릴게요']];
var tipInterval = 5000;
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./components/User/_components/common/Loading/index.tsx









var Loading = function Loading() {
  var getRandomIndex = function getRandomIndex(prevIndex, length) {
    var randomIndex = Math.floor(Math.random() * length);

    if (randomIndex === prevIndex) {
      return getRandomIndex(prevIndex, length);
    }

    return randomIndex;
  };

  var _React$useState = react.useState(Math.floor(Math.random() * tipTexts.length)),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      randomIndex = _React$useState2[0],
      setRandomIndex = _React$useState2[1];

  (0,react_hooks/* useInterval */.Yz)(function () {
    setRandomIndex(function (prev) {
      return getRandomIndex(prev, tipTexts.length);
    });
  }, tipInterval);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StackInnerWrapper, {
      direction: "column",
      alignItems: "center",
      backgroundColor: "transparent",
      gap: 16,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlexTipWrapper, {
        alignItems: "flex-end",
        justifyContent: "center",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StackTipInnerWrapper, {
          direction: "column",
          alignItems: "center",
          gap: 8,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            as: "p",
            variant: "xl-semibold",
            color: "skyblue_500",
            children: "Tip"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            as: "p",
            variant: "md-regular",
            color: "skyblue_500",
            textAlign: "center",
            children: tipTexts[randomIndex].map(function (text) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
                children: [text, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {})]
              }, text);
            })
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* FlexItem */.B5, {
        flexGrow: 1,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Modal.Spinner */.u_.Spinner, {})
      })]
    })
  });
};

/* harmony default export */ var common_Loading = (Loading);

/***/ }),

/***/ 90114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Yz": function() { return /* reexport */ useInterval; },
  "LI": function() { return /* reexport */ useIsomorphicLayoutEffect; },
  "Kr": function() { return /* reexport */ useKeyPress; },
  "_": function() { return /* reexport */ useLocalStorage; },
  "ZN": function() { return /* reexport */ useLocalStorageValue; },
  "s4": function() { return /* reexport */ useMounted; },
  "rC": function() { return /* reexport */ useScrollEndDetection; }
});

// UNUSED EXPORTS: isBrowser, noop, useClientSize, useIntersection, usePageVisibility, useRemoveLocalStorage, useSetLocalStorage, useTimeout

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../packages/react-hooks/src/useClientSize.ts


var useClientSize = function useClientSize(target) {
  var _useState = useState(null),
      width = _useState[0],
      setWidth = _useState[1];

  var _useState2 = useState(null),
      height = _useState2[0],
      setHeight = _useState2[1];

  useEffect(function () {
    if (target.current) {
      setWidth(target.current.clientWidth);
      setHeight(target.current.clientHeight);
    }
  }, [target.current]);
  useResizeObserver(target, function (entry) {
    return setWidth(entry.contentRect.width);
  });
  useResizeObserver(target, function (entry) {
    return setHeight(entry.contentRect.height);
  });
  return {
    width: width,
    height: height
  };
};
;// CONCATENATED MODULE: ../../packages/react-hooks/src/useIntersection.ts

var useIntersection = function useIntersection(ref, options) {
  var _useState = useState(null),
      intersectionObserverEntry = _useState[0],
      setIntersectionObserverEntry = _useState[1];

  useEffect(function () {
    if (ref.current && typeof IntersectionObserver === 'function') {
      var handler = function handler(entries) {
        setIntersectionObserverEntry(entries[0]);
      };

      var observer = new IntersectionObserver(handler, options);
      observer.observe(ref.current);
      return function () {
        setIntersectionObserverEntry(null);
        observer.disconnect();
      };
    }
  }, [ref.current, options.threshold, options.root, options.rootMargin]);
  return intersectionObserverEntry;
};
;// CONCATENATED MODULE: ../../packages/react-hooks/src/useInterval.ts

var useInterval = function useInterval(callback, delay) {
  var savedCallback = (0,react.useRef)(function () {});
  (0,react.useEffect)(function () {
    savedCallback.current = callback;
  });
  (0,react.useEffect)(function () {
    if (delay !== null) {
      var interval = setInterval(function () {
        return savedCallback.current();
      }, delay || 0);
      return function () {
        return clearInterval(interval);
      };
    }

    return undefined;
  }, [delay]);
};
;// CONCATENATED MODULE: ../../packages/react-hooks/src/useIsomorphicLayoutEffect.ts

var useIsomorphicLayoutEffect =  true ? react.useLayoutEffect : 0;
;// CONCATENATED MODULE: ../../packages/react-hooks/src/useKeyPress.ts

var useKeyPress = function useKeyPress(targetKey) {
  var _useState = (0,react.useState)(false),
      keyPressed = _useState[0],
      setKeyPressed = _useState[1];

  var keys = (0,react.useMemo)(function () {
    return targetKey.split(',').map(function (key) {
      return key.trim();
    });
  }, [targetKey]);

  var downHandler = function downHandler(_ref) {
    var key = _ref.key;

    if (keys.some(function (value) {
      return value === key;
    })) {
      setKeyPressed(true);
    }
  };

  var upHandler = function upHandler(_ref2) {
    var key = _ref2.key;

    if (keys.some(function (value) {
      return value === key;
    })) {
      setKeyPressed(false);
    }
  };

  (0,react.useEffect)(function () {
    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);
    return function () {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, []);
  return keyPressed;
};
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(8529);
;// CONCATENATED MODULE: ../../packages/react-hooks/src/useLocalStorage.ts


var isBrowser = true;
var noop = function noop() {};

var useLocalStorage = function useLocalStorage(key, initialValue, options) {
  if (!isBrowser) {
    return [initialValue, noop, noop];
  }

  if (!key) {
    throw new Error('useLocalStorage key may not be falsy');
  }

  var deserializer = options ? options.raw ? function (value) {
    return value;
  } : options.deserializer : JSON.parse;
  var initializer = (0,react.useRef)(function (key) {
    try {
      var serializer = options ? options.raw ? String : options.serializer : JSON.stringify;
      var localStorageValue = localStorage.getItem(key);

      if (localStorageValue !== null) {
        return deserializer(localStorageValue);
      } else {
        initialValue && localStorage.setItem(key, serializer(initialValue));
        return initialValue;
      }
    } catch (_unused) {
      return initialValue;
    }
  });

  var _useState = (0,react.useState)(function () {
    return initializer.current(key);
  }),
      state = _useState[0],
      setState = _useState[1];

  (0,react.useLayoutEffect)(function () {
    return setState(initializer.current(key));
  }, [key]);
  var set = (0,react.useCallback)(function (valOrFunc) {
    try {
      var newState = typeof valOrFunc === 'function' ? // eslint-disable-next-line @typescript-eslint/ban-types
      valOrFunc(state) : valOrFunc;

      if (typeof newState === 'undefined') {
        return;
      }

      var _value;

      if (options) {
        if (options.raw) {
          if (typeof newState === 'string') {
            _value = newState;
          } else {
            _value = JSON.stringify(newState);
          }
        } else if (options.serializer) {
          _value = options.serializer(newState);
        } else {
          _value = JSON.stringify(newState);
        }
      } else {
        _value = JSON.stringify(newState);
      }

      localStorage.setItem(key, _value);
      setState(deserializer(_value));
    } catch (_unused2) {// TODO: Handle error
    }
  }, [key, setState]);
  var remove = (0,react.useCallback)(function () {
    try {
      localStorage.removeItem(key);
      setState(undefined);
    } catch (_unused3) {// TODO: Handle error
    }
  }, [key, setState]);
  return [state, set, remove];
};

var useRemoveLocalStorage = function useRemoveLocalStorage(key) {
  var _useLocalStorage = useLocalStorage(key),
      _useLocalStorage2 = _slicedToArray(_useLocalStorage, 3),
      remove = _useLocalStorage2[2];

  return remove;
};

var useLocalStorageValue = function useLocalStorageValue(key, initialValue, options) {
  var _useLocalStorage3 = useLocalStorage(key, initialValue, options),
      _useLocalStorage4 = (0,slicedToArray/* default */.Z)(_useLocalStorage3, 1),
      value = _useLocalStorage4[0];

  return value;
};

var useSetLocalStorage = function useSetLocalStorage(key, initialValue, options) {
  var _useLocalStorage5 = useLocalStorage(key, initialValue, options),
      setValue = _useLocalStorage5[1];

  return setValue;
};


;// CONCATENATED MODULE: ../../packages/react-hooks/src/useMounted.ts

var useMounted = function useMounted() {
  var _useState = (0,react.useState)(false),
      isMounted = _useState[0],
      setIsMounted = _useState[1];

  (0,react.useEffect)(function () {
    setIsMounted(true);
  }, []);
  return isMounted;
};
;// CONCATENATED MODULE: ../../packages/react-hooks/src/usePageVisibility.ts


function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


var hasDocument = typeof document !== 'undefined';
var vendorEvents = [{
  hidden: 'hidden',
  event: 'visibilitychange',
  state: 'visibilityState'
}];
var isSupported = hasDocument && Boolean(document.addEventListener);

var visibility = function () {
  if (!isSupported) {
    return null;
  }

  var _iterator = _createForOfIteratorHelper(vendorEvents),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var event = _step.value;

      if (event.hidden in document) {
        return event;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return null;
}();

var getHandlerArgs = function getHandlerArgs() {
  if (!visibility) {
    return [true, 'visible'];
  }

  var hidden = visibility.hidden,
      state = visibility.state;
  return [!document[hidden], document[state]];
};

var usePageVisibility = function usePageVisibility() {
  var initiallyVisible = getHandlerArgs();

  var _React$useState = React.useState(initiallyVisible),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isVisible = _React$useState2[0],
      setIsVisible = _React$useState2[1];

  React.useEffect(function () {
    if (isSupported && visibility) {
      var handler = function handler() {
        var currentlyVisible = getHandlerArgs();
        setIsVisible(currentlyVisible);
      };

      document.addEventListener(visibility.event, handler);
      return function () {
        document.removeEventListener(visibility.event, handler);
      };
    }
  }, []);
  return isVisible;
};
;// CONCATENATED MODULE: ../../packages/react-hooks/src/useTimeout.ts

var useTimeout = function useTimeout(fn) {
  var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var ready = React.useRef(false);
  var timeout = React.useRef();
  var callback = React.useRef(fn);
  var isReady = React.useCallback(function () {
    return ready.current;
  }, []);
  var set = React.useCallback(function () {
    ready.current = false;
    timeout.current && clearTimeout(timeout.current);
    timeout.current = setTimeout(function () {
      ready.current = true;
      callback.current();
    }, ms);
  }, [ms]);
  var clear = React.useCallback(function () {
    ready.current = null;
    timeout.current && clearTimeout(timeout.current);
  }, []);
  React.useEffect(function () {
    callback.current = fn;
  }, [fn]);
  return [isReady, clear, set];
};
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(52746);
;// CONCATENATED MODULE: ../../packages/react-hooks/src/useScrollEndDetection.ts


var useScrollEndDetection = function useScrollEndDetection(elementRef) {
  var dependencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var _useState = (0,react.useState)(true),
      isEndDetection = _useState[0],
      setIsEndDetection = _useState[1];

  var handleScroll = (0,react.useCallback)(function () {
    if (!elementRef.current) {
      return;
    }

    var _elementRef$current = elementRef.current,
        scrollTop = _elementRef$current.scrollTop,
        scrollHeight = _elementRef$current.scrollHeight,
        clientHeight = _elementRef$current.clientHeight;

    if (scrollTop + clientHeight + 16 >= scrollHeight) {
      setIsEndDetection(true);
    } else {
      setIsEndDetection(false);
    }
  }, [elementRef].concat((0,toConsumableArray/* default */.Z)(dependencies)));

  var scrollToBottom = function scrollToBottom() {
    if (elementRef.current) {
      elementRef.current.scrollTop = elementRef.current.scrollHeight;
    }
  };

  (0,react.useEffect)(function () {
    var _window$visualViewpor;

    handleScroll();
    var el = elementRef.current;

    if (!el) {
      return;
    }

    el.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
    (_window$visualViewpor = window.visualViewport) === null || _window$visualViewpor === void 0 ? void 0 : _window$visualViewpor.addEventListener('resize', handleScroll);
    return function () {
      var _window$visualViewpor2;

      el.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
      (_window$visualViewpor2 = window.visualViewport) === null || _window$visualViewpor2 === void 0 ? void 0 : _window$visualViewpor2.removeEventListener('resize', handleScroll);
    };
  }, [elementRef, handleScroll]);
  return {
    isEndDetection: isEndDetection,
    handleScroll: handleScroll,
    scrollToBottom: scrollToBottom
  };
};
;// CONCATENATED MODULE: ../../packages/react-hooks/index.ts











/***/ })

}]);